import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

interface ColumnInfoTooltipProps {
  statuses: { name: string; description: string }[]
}

/**
 * Tooltip component for column header info
 * @param statuses - array of objects containing name and description
 */
const ColumnInfoTooltip: React.FC<ColumnInfoTooltipProps> = ({ statuses }) => {
  const classes = useStyles()
  return (
    <div className={classes.tooltipContainer}>
      {statuses.map((status) => (
        <p key={status.name}>
          <strong>{status.name}:</strong> {status.description}
        </p>
      ))}
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  tooltipContainer: {
    padding: theme.spacing(1),
  },
}))

export default ColumnInfoTooltip
